<template>
  <tr>
    <td class="active">
      <template v-if="canChangeMeal">
        <singleselect
            :checked="expressMeal.meal ? expressMeal.meal.id : null"
            :disabled="!canEdit || !typeId"
            :errors="errors"
            :options="availableMeals"
            :title="trans('menu_planner.entity.finalMeal')"
            name="finalMeal"
            @option-selected="changeMeal"
        />
      </template>
      <template v-else>
        <span class="error">{{ expressMeal.meal.name }}</span>
      </template>
    </td>
    <template v-if="loading">
      <td><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"/></td>
      <td><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"/></td>
      <td><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"/></td>
      <td><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"/></td>
      <td><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"/></td>
      <td><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"/></td>
      <td/>
    </template>
    <template v-else-if="!loading && expressMeal.meal">
      <td>
        <span v-text="expressMeal.meal.id"></span>
      </td>
      <td>
        <span v-text="Math.round(expressMeal.meal.rate * 100) / 100"></span>
      </td>
      <td>
        <template v-for="mealBadge in expressMeal.meal.mealBadges">
          <div v-if="mealBadge.validFrom <= date && mealBadge.validTo >= date" :key="mealBadge.id">
            <a @click.prevent="showMealBadge(mealBadge.badge.id)">
              <i class="fa fa-link"></i>&nbsp;{{ mealBadge.badge.name }}
            </a>
          </div>
        </template>
      </td>
      <td>
        <span v-for="(tag, tagIndex) in mealTags" :key="tagIndex">{{ tag.value }} <br></span>
      </td>
      <td>
        <div>
          <template v-for="(serving, servingIndex) in expressMeal.meal.servings">
            <span :key="`span-${servingIndex}`" v-text="serving.size"></span>
            <br :key="`br-${servingIndex}`"/>
          </template>
        </div>
      </td>
      <td>
        <div>
          <template v-for="(serving, servingIndex) in expressMeal.meal.servings">
            <span :key="`span-${servingIndex}`" v-text="dcNumberFormat(serving.productionCost)"></span>
            <br :key="`br-${servingIndex}`"/>
          </template>
        </div>
      </td>
      <td>
        <div>
          <template v-for="(serving, servingIndex) in expressMeal.meal.servings">
            <span
                :key="`span-${servingIndex}`"
                :style="serving.suggestedLowestPrice === null ? 'color: red' : ''"
                v-text="serving.suggestedLowestPrice === null ? 'Brak ceny' : dcNumberFormat(serving.suggestedLowestPrice)"
            />
            <br :key="`br-${servingIndex}`"/>
          </template>
        </div>
      </td>
      <td>
        <div class="btn-set pull-right">
          <button class="btn btn-danger" :disabled="!canEdit" @click="remove">
            {{ trans('menu_planner_select.remove_meal') }}
          </button>
        </div>
      </td>
    </template>
    <template v-else>
      <td/>
      <td/>
      <td/>
      <td/>
      <td/>
      <td/>
      <td/>
    </template>
  </tr>
</template>

<script>
import singleselect from '../singleselect.vue'
import mixins from '@js/mixins'

export default {
  components: {
    singleselect,
  },
  mixins: [mixins],
  props: {
    availableMeals: {
      type: Array,
      default: () => [],
    },
    brand: {
      type: [String, Number],
      default: '',
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    date: {
      type: [Date, String],
      default: '',
    },
    expressMeal: {
      type: Object,
      default: () => {
      },
    },
    index: {
      type: [String, Number],
      default: '',
    },
    typeId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      errors: {},
      loading: 0,
      mealRate: null,
      mealTags: [],
    }
  },
  computed: {
    canChangeMeal() {
      return this.expressMeal.meal === undefined
          || this.availableMeals.some(item => item.id === this.expressMeal.meal.id)
    },
  },
  mounted() {
    if (this.expressMeal.meal) {
      this.setTagsForMeal(this.expressMeal.meal.id)
      this.setRateForMeal(this.expressMeal.meal.id)
    }
  },
  methods: {
    changeMeal(meal) {
      if (!meal) {
        this.remove()
      } else if (this.expressMeal.meal) {
        this.removeAndSave(meal)
      } else if (meal) {
        this.save(meal)
      }
    },
    remove() {
      if (this.expressMeal.id) {
        this.loading++

        this.$http.delete(
          Routing.generate('api_remove_meal_planner', {
            id: this.expressMeal.id,
            // eslint-disable-next-line camelcase
            select_type_id: this.typeId
          }), {
            meal: null,
            date: this.date,
          })
          .then(() => {
            this.$emit('remove')
            this.mealTags = []
            this.mealRate = null
            this.loading--
          }, response => {
            this.handleAjaxError(response)
            this.loading--
          })
      } else {
        this.$emit('remove')
      }
    },
    removeAndSave(meal) {
      this.loading++

      this.$http.delete(
        Routing.generate('api_remove_meal_planner', {
          id: this.expressMeal.id,
          // eslint-disable-next-line camelcase
          select_type_id: this.typeId
        }), {
          meal: null,
          date: this.date,
        })
        .then(() => {
          this.save(meal)
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
    },
    save(meal) {
      this.loading++
      const data = {
        meal: meal.id,
        date: this.date,
        mpm: this.expressMeal.id || null,
        brand: this.brand,
        typeId: this.typeId,
      }

      this.$http.post(Routing.generate('api_post_menu_express_planner'), data)
        .then(response => {
          if (!this.expressMeal.meal) {
            this.$emit('set', this.index + 1, {})
          }

          this.setTagsForMeal(data.meal)
          this.setRateForMeal(data.meal)
          this.$emit('set', this.index, response.data)
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
    },
    setRateForMeal(meal) {
      this.loading++

      const url = Routing.generate('api_get_menu_planner_meal_rate', { meal: meal })
      this.$http.get(url).then(response => {
        this.mealRate = response.data
        this.loading--
      }, () => {
        this.loading--
      })
    },
    setTagsForMeal(meal) {
      this.loading++

      const url = Routing.generate('api_get_menu_planner_meal_tags', { meal: meal })
      this.$http.get(url).then(response => {
        this.mealTags = response.data
        this.loading--
      }, () => {
        this.loading--
      })
    },
    showMealBadge(badgeId) {
      window.open(Routing.generate('badge_show', { id: badgeId }), '_blank')
    },
  },
}
</script>

<style>
.error {
  color: red;
}
</style>
